import React, { ComponentProps } from 'react';
import { FormResultProvider } from 'src/hooks/useFormResultController';
import StatsigProviderMask from 'atoms/AbTesting/AbTestingProvider';
import { PathToProOfferOverrideProvider } from './usePathToProOfferOverride';
import { HeaderDesignControllerProvider } from './useHeaderDesignController';
import { PopupControllerProvider } from './usePopupController';

const PROVIDERS = [
  FormResultProvider,
  StatsigProviderMask,
  PathToProOfferOverrideProvider,
  HeaderDesignControllerProvider,
  PopupControllerProvider,
];

const combineProviders = (): React.FC<any> => {
  return PROVIDERS.reduce(
    (AccComponent, Provider) => {
      const AggregatedComponents = ({ children }: ComponentProps<React.FC<any>>): JSX.Element => (
        <AccComponent>
          <Provider>{children}</Provider>
        </AccComponent>
      );

      return AggregatedComponents;
    },
    ({ children }) => <>{children}</>
  );
};

const ContextProviders = combineProviders();

export default ContextProviders;
